import React from "react";
import { Link } from "react-router-dom";
function changebg() {

  var num = Math.ceil(Math.random() * 2);
  document.body.background = "assets/img/loginBackground/loginback_" + num + ".jpg";
  document.body.style.backgroundSize = "cover";

}
export default () => (
  <div className="container-fluid" onLoad={changebg()}>
   
  <div className="row d-flex align-items-center justify-content-center vh-100">
    <div
      className="col-10 col-md-7 col-lg-6 col-xl-4 t-sifreAlani"       
    >
      <div className="row no-gutters d-flex justify-content-center px-4">
        {/* LOGO */}
        <div className="col-12 d-flex justify-content-center pb-2">
          <i className="t-icon-sad t-loginSifreAlBaslikIcon" />
        </div>
        <hr style={{ width: "100%" }} className="pt-3" />
        <div className="col-12 d-flex justify-content-center pb-3 t-loginSifreAlBaslik text-center">
        Üzgünüz, Beklenmeyen Bir Hata Oluştu.
        </div>
        <hr style={{ width: "100%" }} className="pt-3" />
        <div className="col-12" />
        <div className="col-auto pt-4 px-1">
         
          <Link to="/Home/Dashboard" className="t-loginGirisButton">Ana Sayfa
          <i
              className="t-icon-arrow-right2 pl-2"
              style={{ fontSize: "14pt" }}
            />
          </Link>
                  
        </div>
      </div>
    </div>
  </div>
</div>
);
